import createAxiosInstance from './axiosConfig';
import { ObservacaoParcelaDTO } from '../../app/shared/dto/observacaoParcelaDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/operacaoParcelaController');

export default class ObservacaoParcelaService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async buscarObservacao(numeroContrato: string, numeroParcela: number) {
    return await this.axios.get(`/buscarObservacao?numeroContrato=${numeroContrato}&numeroParcela=${numeroParcela}`);
  }

  async salvarObservacao(dto: ObservacaoParcelaDTO) {
    return await this.axios.post(`/salvarObservacao`, dto);
  }
}